var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9362",
    "data-name": "Group 9362",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M5,0a5,5,0,1,0,5,5A5,5,0,0,0,5,0Z",
    fill: "#434db8",
    stroke: "#434db8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M5,0a5,5,0,1,0,5,5A5,5,0,0,0,5,0ZM4.375,4.375a.625.625,0,0,1,1.25,0V7.5a.625.625,0,0,1-1.25,0ZM5,3.135a.625.625,0,1,1,.625-.625A.625.625,0,0,1,5,3.135Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.59c32da46baeca4dc58a9eb1977473b6.svg";
export { ForwardRef as ReactComponent };